function normalizedSearchValue(value: unknown): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toLocaleLowerCase();
}

export function filterCityOptions(
  value: unknown,
  options: readonly string[],
  priorityOptions: readonly string[] = []
): string[] {
  const seen = new Set<string>();
  const allCities = [...priorityOptions, ...options].filter(city => {
    const key = normalizedSearchValue(city);
    if (!key || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
  const query = normalizedSearchValue(value);

  return query
    ? allCities.filter(city => normalizedSearchValue(city).includes(query))
    : allCities;
}
